export { tabsTheme as Tabs } from './tabs';

//# sourceMappingURL=index.js.map